import React from 'react';
import DebtReliefView from 'partial/OfferManager/modules/DebtRelief/DebtReliefView';
import LoadingMask from 'partial/OfferManager/LoadingMask';
import { useSeenModulePixel } from 'hook/helper.hook';
import { getViewModuleTrackingAttributes } from 'helpers/tracking.helpers';
import { DEBT_RELIEF_ACTION } from 'types/morph.pagePosition.constants';
import { formatIncome } from 'helpers/money.helper';

function DebtReliefController(props) {
  const unsecuredDebt =
    props.creditInfo.debtAnalysis.creditCardDebt.totalDebt +
    props.creditInfo.debtAnalysis.otherLoanDebt.totalDebt;

  const heading = `Take control of your ${formatIncome(
    Math.round(unsecuredDebt / 1000) * 1000,
  )} debt with the help of debt relief experts`;

  const atr = getViewModuleTrackingAttributes({
    pagePosition: DEBT_RELIEF_ACTION,
    modulePosition: props.modulePosition,
    vertical: 'Debt Relief',
  });

  const seenPixel = useSeenModulePixel(atr);

  if (!props.offers) {
    return <LoadingMask />;
  }

  return (
    <DebtReliefView
      {...props}
      heading={heading}
      unsecuredDebt={unsecuredDebt}
      seenPixel={seenPixel}
    />
  );
}

export default DebtReliefController;
